import Mustache from 'mustache';
import modals from './modal';

/**
 * Usage:
 * <figure data-chart-modal-data='stringified json data needed to show populate modal'>
 *   <a href="..." class="js--open-modal">open modal</a>
 * </figure>
 */

const chartModals = {
  template: '',
  modals: {},

  showModal: function(data) {
    if(data && data.uuid) {
      const modalId = data.uuid;

      if(!this.modals[modalId]) {
        const success = this.createModal(modalId, data);
        if(success) {
          this.modals[modalId].show();
        }
      } else {
        this.modals[modalId].show();
      }
    }
  },

  createModal: function(modalId, data) {
    const template = this.template;
    const markup = Mustache.render(template, data);

    const containerElement = document.createElement('div');
    containerElement.innerHTML = markup;
    const element = containerElement.firstElementChild;

    document.body.appendChild(element);

    const chartDialog = modals.createModal(element);

    this.modals[modalId] = chartDialog;
    this.modals[modalId].show();

  },

  onChartLinkClick: function(event) {
    const matchEl = event.target.closest('.js--open-chart-modal');
    if(matchEl) {
      try {
        const data = JSON.parse(matchEl.closest('[data-chart-modal-data]').dataset.chartModalData);

        if(data && data.uuid) {
          event.preventDefault();
          this.showModal(data);
        }
      } catch(e) {/* */}
    }
  },

  init: function() {
    const templateElement = document.getElementById('chart-modal-template');

    if(templateElement) {
      this.template = templateElement.innerHTML;
      Mustache.parse(this.template);

      // Attach event listeners
      document.addEventListener('click', this.onChartLinkClick.bind(this));
    }
  }
};

export default chartModals;
